// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hwlswufemzbxdylrtaxv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh3bHN3dWZlbXpieGR5bHJ0YXh2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMwOTk3MTMsImV4cCI6MjA2ODY3NTcxM30.PtkMo3JOdIdNXRbkr4uzoNpcxHgJclclY-ZbzXN45H4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});